import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "@ts-digital/vrc";
import { useState } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import Stepper from "../../../classificator/stepper";
import "./style.css";

import Summary from "./summary";
import FormCompensa from "./formCompensa";
import FormNew from "./formNew";
import Content3 from "./content3";
import { useDispatch, useSelector } from "react-redux";
import LoaderSimple from "../../../general/loader";
import moment from "moment";
import { createMergedDeadline } from "../../../../store/actions/deadlines/accountant";
import { DATETIME_FORMATZ_FOR_API } from "../../../../constants/constants";

const DialogMerge = props => {
  const {      
    onClose,
    selectedRows,
    visible,
    mergeType
  } = props;

  const navigate = useNavigate();
  /** REDUX STATE */
  // numero dello stepper
  const [stepNumber, setStepNumber] = useState(1);
  // input del form di creazione della nuova scadenza
  const [deadlineDescription, setDeadlineDescription] = useState(null);
  const [deadlineDate, setDeadlineDate] = useState(moment());
  const [deadlineCompensationDate, setDeadlineCompensationDate] = useState(moment());
  const [deadlinePayment, setDeadlinePayment] = useState(null);
  // il feedback è il campo che mostra il risultato del merge, con relativi errori
  const [feedback, setFeedback] = useState(null);
  const [errorDate, setErrorDate] = useState(null);
  const [errorDescription, setErrorDescription] = useState(null);
  const [errorPayment, setErrorPayment] = useState(null);
  const [isZeroResidual, setIsZeroResidual] = useState(false);
  // id della nuova scadenza creata
  const [newDeadline, setNewDeadline] = useState(null);

  const merge = useSelector(state => state.deadlinesAccountant.merge);
  const dispatch = useDispatch();

  const step1 = useIntl().formatMessage({ id: "deadlines.merge.step1" });
  const step2 = useIntl().formatMessage({ id: "deadlines.merge.step2" });
  const step3 = useIntl().formatMessage({ id: "deadlines.merge.step3" });
  const cancelText = useIntl().formatMessage({ id: "actions.cancel" });
  const genericBack = useIntl().formatMessage({ id: "generic.back" });
  const closeText = useIntl().formatMessage({ id: "actions.close" });
  const genericNext = useIntl().formatMessage({ id: "generic.next" });
  const buttonCompensationText =   useIntl().formatMessage({
    id: "deadlines.merge.btnCompensation"
  });
  const step1c = useIntl().formatMessage({ id: "deadlines.merge.step1c" });
  const saveText =  useIntl().formatMessage({ id: "deadlines.merge.save" });
  const goDeadlineText = useIntl().formatMessage({ id: "actions.goDeadline" });

  useEffect(() => {
    const total = selectedRows.reduce((a, b) => {
      return (typeof a === "object" ? a.amount : a) + b.amount;
    });
    setIsZeroResidual(total === 0);
  }, [selectedRows]);

  let steps = [
    {
      number: 1,
      title: step1
    },
    {
      number: 2,
      title: step2
    },
    {
      number: 3,
      title: step3
    }
  ];

  const prevStep = () => {
    if (stepNumber === 1) {
      onClose(false);
    } else if (
      (stepNumber === 3 && !isOpposite) ||
      (stepNumber === 4 && isOpposite)
    ) {
      onClose(true);
    } else {
      setStepNumber(stepNumber - 1);
    }
  };

  const nextStep = () => {
    if (
      stepNumber === 1 ||
      (stepNumber === 2 && isOpposite && !isZeroResidual)
    ) {
      setStepNumber(stepNumber + 1);
    } else if (
      (stepNumber === 2 && !isOpposite) ||
      (stepNumber === 3 && isOpposite && !isZeroResidual) ||
      (stepNumber === 2 && isOpposite && isZeroResidual)
    ) {
      onSave();
    } else if (stepNumber === 3 && isOpposite && isZeroResidual) {
      onClose(true);
    } else {
      navigate("/scadenza/" + newDeadline);
    }
  };

  const onSave = async() => {
    setFeedback(null);
    const deadlinesIds = await selectedRows.map(el => {return el.id;});
    // Controllo che tutti i campi siano compilati correttamente
    if (
      !isZeroResidual &&
      (!deadlinePayment || !deadlineDescription || !deadlineDate)
    ) {
      setErrorDate(!deadlineDate);
      setErrorDescription(!deadlineDescription);
      setErrorPayment(!deadlinePayment);
      return;
    }
    
    dispatch(createMergedDeadline(            
      deadlinesIds,
      deadlineDescription,
      deadlineDate.format(DATETIME_FORMATZ_FOR_API),
      deadlinePayment,
      deadlineCompensationDate
    ))
      .then(res => {
        // Se chiamata a buon fine, imposto l'id della nuova scadenza, porto il feedback in ok e mi sposto sul terzo step
        setNewDeadline(res.id);
        setFeedback("ok");
        setStepNumber(isOpposite && !isZeroResidual ? 4 : 3);
      })
      .catch(error => {
        // Se chiamata ritorna un errore, porto il feedback in errore e mi sposto sul terzo step
        setFeedback(error);
        setStepNumber(isOpposite && !isZeroResidual ? 4 : 3);
      });
  };

  const footer = () => {
    // Condizioni per renderizzare i pulsanti, unica importante, se sono sul terzo step e il feedback è un errore, rimuovo il secondo pulsante.
    return (
      <div className={`deadlinesDialogMerge-footer step${stepNumber}`}>
        <Button
          disabled={merge.isSavingMerge}
          onClick={prevStep}
          kind="secondary"
        >
          {stepNumber === 1 &&
            cancelText}
          {(stepNumber === 2 || (isOpposite && stepNumber === 3)) &&
            genericBack}
          {((stepNumber === 3 && !isOpposite) || stepNumber === 4) &&
            closeText}
        </Button>

        {(stepNumber !== 3 ||
          (!isOpposite && stepNumber === 3 && feedback === "ok") ||
          stepNumber !== 4 ||
          (isOpposite && stepNumber === 4 && feedback === "ok")) && (
          <Button disabled={merge.isSavingMerge} onClick={nextStep}>
            {stepNumber === 1 &&
              genericNext}
            {stepNumber === 2 &&
              isOpposite &&
              buttonCompensationText
            }
            {((stepNumber === 2 && !isOpposite) ||
              (stepNumber === 3 && isOpposite && !isZeroResidual)) &&
              saveText
            }
            {((stepNumber === 3 && !isOpposite) ||
              (stepNumber === 4 && isOpposite && !isZeroResidual)) &&
              goDeadlineText
            }
            {stepNumber === 3 &&
              isOpposite &&
              isZeroResidual &&
              closeText}
          </Button>
        )}
      </div>
    );
  };

  // ordino l'array di soli amount
  const isOpposite = mergeType === "compensation";

  /** Se si tratta di compensazione devo avere uno step ulteriore per inserire la data di compensazione
   * Ma potrei anche non avere lo step di nuova scadenza in caso di compensazione a 0
   */
  if (isOpposite) {
    steps = [
      {
        number: 1,
        title: step1
      },
      {
        number: 2,
        title: step1c
      },
      {
        number: 3,
        title: step2
      },
      {
        number: 4,
        title: step3
      }
    ];

    /** Rimuovo lo step di creazione residuo */
    if (isZeroResidual) {
      steps.splice(2, 1);
      steps[2].number = 3;
    }
  }

  const getMessage = () => {
    let messageId = "";
    if (stepNumber === 1) {
      if (isOpposite) {
        messageId = "deadlines.merge.titleCompensation";
      } else {
        messageId = "deadlines.merge.titleMerge";
      }
    } else {
      messageId = "deadlines.merge.titleStep2";
    }
    return messageId;
  };

  const renderSummaryCompensation = () => {
    return stepNumber === 2 && isOpposite ? (
      <FormCompensa
        selectedRows={selectedRows}
        deadlineDate={deadlineCompensationDate}
        setDeadlineDate={setDeadlineCompensationDate}
      />
    ) : null;
  };

  const renderNewForm = () => {
    return (
      ((stepNumber === 2 && !isOpposite) ||
        (stepNumber === 3 && isOpposite && !isZeroResidual)) &&
      (merge.isSavingMerge ? (
        <div className="deadlinesDialogMerge-loader">
          <LoaderSimple />
        </div>
      ) : (
        <FormNew
          deadlineDate={deadlineDate}
          deadlineDescription={deadlineDescription}
          deadlinePayment={deadlinePayment}
          setDeadlineDate={value => {
            setDeadlineDate(value);
            setErrorDate(false);
          }}
          setDeadlineDescription={value => {
            setDeadlineDescription(value);
            setErrorDescription(false);
          }}
          setDeadlinePayment={value => {
            setDeadlinePayment(value);
            setErrorPayment(false);
          }}
          selectedRows={selectedRows}
          errorDate={errorDate}
          errorDescription={errorDescription}
          errorPayment={errorPayment}
        />
      ))
    );
  };

  return (
    <Modal
      visible={visible}
      outsideClosable={false}
      title={<FormattedMessage id={getMessage()} />}
      onClose={() => onClose(stepNumber === 3)}
      footer={footer()}
    >
      <div className={"deadlinesDialogMerge-root"}>
        <Stepper
          currentStep={stepNumber}
          setCurrentStep={stepNumber => setStepNumber(stepNumber)}
          steps={steps}
          readOnly
        />
        {stepNumber === 1 && (
          <Summary mergeType={mergeType} selectedRows={selectedRows} />
        )}
        {renderSummaryCompensation()}
        {renderNewForm()}
        {((stepNumber === 3 && !isOpposite) ||
          (stepNumber === 3 && isOpposite && isZeroResidual) ||
          (stepNumber === 4 && isOpposite && !isZeroResidual)) && (
          <Content3
            feedback={feedback}
            isOpposite={isOpposite}
            selectedRows={selectedRows}
            isZeroResidual={isZeroResidual}
          />
        )}
      </div>
    </Modal>
  );
};

export default DialogMerge;
